import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthModal({ open, onOpenChange, initialMode = "signup", onSuccess }) {
  const [mode, setMode] = useState(initialMode);
  const { login, signup, loading } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  React.useEffect(() => { setMode(initialMode); }, [initialMode, open]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "signup") {
        await signup(form.email, form.password, form.name || form.email.split("@")[0]);
        toast.success("Welcome to ajobforsure!");
      } else {
        await login(form.email, form.password);
        toast.success("Welcome back!");
      }
      onSuccess?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="auth-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-black">
            {mode === "signup" ? "Start hustling." : "Welcome back."}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          {mode === "signup" && (
            <div>
              <Label>Name</Label>
              <Input value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})}
                     placeholder="Alex Rivera" required data-testid="auth-name-input"/>
            </div>
          )}
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})}
                   placeholder="you@hustling.com" required data-testid="auth-email-input"/>
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})}
                   placeholder="min 6 chars" minLength={6} required data-testid="auth-password-input"/>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="auth-submit-btn">
            {loading ? "…" : (mode === "signup" ? "Create account" : "Log in")}
          </button>
          <p className="text-sm text-center text-[var(--stone)]">
            {mode === "signup" ? "Already have one? " : "New here? "}
            <button type="button" onClick={()=>setMode(mode === "signup" ? "login" : "signup")}
                    className="text-[var(--forest)] font-semibold underline" data-testid="auth-switch-mode">
              {mode === "signup" ? "Log in" : "Sign up"}
            </button>
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
